module.exports = __webpack_public_path__ + "img/20190523204013微信截图_20190523204344.441b38ed.png";